import { IconButton, Tooltip } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';

function BewertungsCard({ id, item }) {
    const [color, setColor] = useState(null);
    const [tooltip, setTooltip] = useState('');

    useEffect(() => {
        if (!id || typeof id.bewertung !== 'number') return;

        // Set color
        switch (id.bewertung) {
            case 0:
                setColor('#e8f5e9');
                break;
            case 1:
                setColor('#fff3e0');
                break;
            case 2:
                setColor('#ffcdd2');
                break;
            case 3:
                setColor('#e8f5e9');
                break;
            default:
                setColor(null);
        }

        // Set tooltip text
        const found = item?.bewertung?.find((e) => e.id === id.bewertung);
        setTooltip(found?.bzh ?? '');
    }, [id, item]);

    if (!id || typeof id.bewertung !== 'number') return null;

    return (
        <Tooltip title={tooltip}>
            <IconButton sx={{ bgcolor: color }}>
                {id.bewertung === 0 && <CheckCircleOutlineOutlinedIcon />}
                {id.bewertung === 1 && <RadioButtonCheckedOutlinedIcon />}
                {id.bewertung === 2 && <NotInterestedOutlinedIcon />}
                {id.bewertung === 3 && <MonetizationOnOutlinedIcon />}
            </IconButton>
        </Tooltip>
    );
}

export default BewertungsCard;
